export default [
  { link: '/age/beremennost-i-rody', content: 'Беременность и роды' },
  { link: '/age/do-1-goda', content: 'до 1 года' },
  { link: '/age/1-3-goda-rannee-detstvo-yaselnyy-vozrast', content: '1—3 года' },
  { link: '/age/4-6-let-doshkolnyy-vozrast', content: '4—6 лет' },
  { link: '/age/7-10-let-mladshiy-shkolnyy-vozrast', content: '7—10 лет' },
  { link: '/age/podrostki', content: 'Подростки' },
];
